import { FC, ReactElement, ReactNode } from "react";
import { FuriganaText } from "@/components/commons/FuriganaText";
import { RichText } from "@/components/commons/RichText";

type FormattedTextProps = {
  /** Learning content with markup and/or `[base]{reading}` furigana */
  text?: string | null;
  /** Single-line context (e.g. `noWrap`): render line breaks as spaces */
  inline?: boolean;
};

const renderFurigana = (value: string): ReactNode => <FuriganaText text={value} />;

/**
 * Common renderer for learning content: RichText (markup) → FuriganaText (ruby).
 * Add new conversions as another layer here.
 *
 * Markup is parsed first, so it must wrap the whole `[base]{reading}` group:
 * `<u>[漢字]{かんじ}</u>` works, `[<u>漢字</u>]{かんじ}` does not.
 */
export const FormattedText: FC<FormattedTextProps> = ({ text, inline }): ReactElement => (
  <RichText text={text} renderText={renderFurigana} inline={inline} />
);
